"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AuthController", {
    enumerable: true,
    get: function() {
        return AuthController;
    }
});
const _common = require("@nestjs/common");
const _express = require("express");
const _passport = require("@nestjs/passport");
const _config = require("@nestjs/config");
const _nocodbsdk = require("nocodb-sdk");
const _ejs = /*#__PURE__*/ _interop_require_wildcard(require("ejs"));
const _models = require("src/models");
const _usersservice = require("~/services/users/users.service");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _globalguard = require("~/guards/global/global.guard");
const _catchError = require("~/helpers/catchError");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _publicapilimiterguard = require("~/guards/public-api-limiter.guard");
const _config1 = require("~/interface/config");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let AuthController = class AuthController {
    async signup(req, res) {
        if (this.config.get('auth', {
            infer: true
        }).disableEmailAuth) {
            _catchError.NcError.forbidden('Email authentication is disabled');
        }
        res.json(await this.usersService.signup({
            body: req.body,
            req,
            res
        }));
    }
    async refreshToken(req, res) {
        res.json(await this.usersService.refreshToken({
            body: req.body,
            req,
            res
        }));
    }
    async signin(req, res) {
        if (this.config.get('auth', {
            infer: true
        }).disableEmailAuth) {
            _catchError.NcError.forbidden('Email authentication is disabled');
        }
        await this.setRefreshToken({
            req,
            res
        });
        res.json(await this.usersService.login(req.user, req));
    }
    async signOut(req, res) {
        if (!(req.isAuthenticated == null ? void 0 : req.isAuthenticated.call(req))) {
            _catchError.NcError.forbidden('Not allowed');
        }
        res.json(await this.usersService.signOut({
            req,
            res
        }));
    }
    async googleSignin(req, res) {
        await this.setRefreshToken({
            req,
            res
        });
        res.json(await this.usersService.login(req.user, req));
    }
    googleAuthenticate() {
    // google strategy will take care the request
    }
    async me(req) {
        const user = _extends({}, req.user, {
            roles: (0, _nocodbsdk.extractRolesObj)(req.user.roles),
            workspace_roles: (0, _nocodbsdk.extractRolesObj)(req.user.workspace_roles),
            base_roles: (0, _nocodbsdk.extractRolesObj)(req.user.base_roles)
        });
        await _models.PresignedUrl.signMetaIconImage(user);
        return user;
    }
    async passwordChange(req, res) {
        if (!(req.isAuthenticated == null ? void 0 : req.isAuthenticated.call(req))) {
            _catchError.NcError.forbidden('Not allowed');
        }
        await this.usersService.passwordChange({
            user: req['user'],
            req,
            body: req.body
        });
        // set new refresh token
        await this.setRefreshToken({
            req,
            res
        });
        res.json({
            msg: 'Password has been updated successfully'
        });
    }
    async passwordForgot(req) {
        await this.usersService.passwordForgot({
            siteUrl: req.ncSiteUrl,
            body: req.body,
            req
        });
        return {
            msg: 'Please check your email to reset the password'
        };
    }
    async tokenValidate(tokenId) {
        await this.usersService.tokenValidate({
            token: tokenId
        });
        return {
            msg: 'Token has been validated successfully'
        };
    }
    async passwordReset(req, tokenId, body) {
        await this.usersService.passwordReset({
            token: tokenId,
            body: body,
            req
        });
        return {
            msg: 'Password has been reset successfully'
        };
    }
    async emailVerification(req, tokenId) {
        await this.usersService.emailVerification({
            token: tokenId,
            req
        });
        return {
            msg: 'Email has been verified successfully'
        };
    }
    async renderPasswordReset(req, res, tokenId) {
        try {
            res.send(_ejs.render((await Promise.resolve().then(()=>/*#__PURE__*/ _interop_require_wildcard(require("~/modules/auth/ui/auth/resetPassword")))).default, {
                ncPublicUrl: process.env.NC_PUBLIC_URL || '',
                token: tokenId,
                baseUrl: `/`
            }));
        } catch (e) {
            return res.status(400).json({
                msg: e.message
            });
        }
    }
    async setRefreshToken({ res, req }) {
        await this.usersService.setRefreshToken({
            res,
            req
        });
    }
    constructor(usersService, appHooksService, config){
        this.usersService = usersService;
        this.appHooksService = appHooksService;
        this.config = config;
    }
};
_ts_decorate([
    (0, _common.Post)([
        '/auth/user/signup',
        '/api/v1/db/auth/user/signup',
        '/api/v1/auth/user/signup',
        '/api/v2/auth/user/signup'
    ]),
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _common.Req)()),
    _ts_param(1, (0, _common.Res)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config1.NcRequest === "undefined" ? Object : _config1.NcRequest,
        typeof _express.Response === "undefined" ? Object : _express.Response
    ]),
    _ts_metadata("design:returntype", Promise)
], AuthController.prototype, "signup", null);
_ts_decorate([
    (0, _common.Post)([
        '/auth/token/refresh',
        '/api/v1/db/auth/token/refresh',
        '/api/v1/auth/token/refresh',
        '/api/v2/auth/token/refresh'
    ]),
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _common.Req)()),
    _ts_param(1, (0, _common.Res)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config1.NcRequest === "undefined" ? Object : _config1.NcRequest,
        typeof _express.Response === "undefined" ? Object : _express.Response
    ]),
    _ts_metadata("design:returntype", Promise)
], AuthController.prototype, "refreshToken", null);
_ts_decorate([
    (0, _common.Post)([
        '/auth/user/signin',
        '/api/v1/db/auth/user/signin',
        '/api/v1/auth/user/signin',
        '/api/v2/auth/user/signin'
    ]),
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard, (0, _passport.AuthGuard)('local')),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _common.Req)()),
    _ts_param(1, (0, _common.Res)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config1.NcRequest === "undefined" ? Object : _config1.NcRequest,
        typeof _express.Response === "undefined" ? Object : _express.Response
    ]),
    _ts_metadata("design:returntype", Promise)
], AuthController.prototype, "signin", null);
_ts_decorate([
    (0, _common.UseGuards)(_globalguard.GlobalGuard),
    (0, _common.Post)([
        '/api/v1/auth/user/signout',
        '/api/v2/auth/user/signout'
    ]),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _common.Req)()),
    _ts_param(1, (0, _common.Res)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config1.NcRequest === "undefined" ? Object : _config1.NcRequest,
        typeof _express.Response === "undefined" ? Object : _express.Response
    ]),
    _ts_metadata("design:returntype", Promise)
], AuthController.prototype, "signOut", null);
_ts_decorate([
    (0, _common.Post)(`/auth/google/genTokenByCode`),
    (0, _common.HttpCode)(200),
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard, (0, _passport.AuthGuard)('google')),
    _ts_param(0, (0, _common.Req)()),
    _ts_param(1, (0, _common.Res)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config1.NcRequest === "undefined" ? Object : _config1.NcRequest,
        typeof _express.Response === "undefined" ? Object : _express.Response
    ]),
    _ts_metadata("design:returntype", Promise)
], AuthController.prototype, "googleSignin", null);
_ts_decorate([
    (0, _common.Get)('/auth/google'),
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard, (0, _passport.AuthGuard)('google')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], AuthController.prototype, "googleAuthenticate", null);
_ts_decorate([
    (0, _common.Get)([
        '/auth/user/me',
        '/api/v1/db/auth/user/me',
        '/api/v1/auth/user/me',
        '/api/v2/auth/user/me'
    ]),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_param(0, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config1.NcRequest === "undefined" ? Object : _config1.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], AuthController.prototype, "me", null);
_ts_decorate([
    (0, _common.Post)([
        '/user/password/change',
        '/api/v1/db/auth/password/change',
        '/api/v1/auth/password/change',
        '/api/v2/auth/password/change'
    ]),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    (0, _extractidsmiddleware.Acl)('passwordChange', {
        scope: 'org'
    }),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _common.Req)()),
    _ts_param(1, (0, _common.Res)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config1.NcRequest === "undefined" ? Object : _config1.NcRequest,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], AuthController.prototype, "passwordChange", null);
_ts_decorate([
    (0, _common.Post)([
        '/auth/password/forgot',
        '/api/v1/db/auth/password/forgot',
        '/api/v1/auth/password/forgot',
        '/api/v2/auth/password/forgot'
    ]),
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config1.NcRequest === "undefined" ? Object : _config1.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], AuthController.prototype, "passwordForgot", null);
_ts_decorate([
    (0, _common.Post)([
        '/auth/token/validate/:tokenId',
        '/api/v1/db/auth/token/validate/:tokenId',
        '/api/v1/auth/token/validate/:tokenId',
        '/api/v2/auth/token/validate/:tokenId'
    ]),
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _common.Param)('tokenId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], AuthController.prototype, "tokenValidate", null);
_ts_decorate([
    (0, _common.Post)([
        '/auth/password/reset/:tokenId',
        '/api/v1/db/auth/password/reset/:tokenId',
        '/api/v1/auth/password/reset/:tokenId',
        '/api/v2/auth/password/reset/:tokenId'
    ]),
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _common.Req)()),
    _ts_param(1, (0, _common.Param)('tokenId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config1.NcRequest === "undefined" ? Object : _config1.NcRequest,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], AuthController.prototype, "passwordReset", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/auth/email/validate/:tokenId',
        '/api/v1/auth/email/validate/:tokenId',
        '/api/v2/auth/email/validate/:tokenId'
    ]),
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _common.Req)()),
    _ts_param(1, (0, _common.Param)('tokenId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config1.NcRequest === "undefined" ? Object : _config1.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], AuthController.prototype, "emailVerification", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/auth/password/reset/:tokenId',
        '/api/v2/db/auth/password/reset/:tokenId',
        '/auth/password/reset/:tokenId'
    ]),
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    _ts_param(0, (0, _common.Req)()),
    _ts_param(1, (0, _common.Res)()),
    _ts_param(2, (0, _common.Param)('tokenId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config1.NcRequest === "undefined" ? Object : _config1.NcRequest,
        typeof _express.Response === "undefined" ? Object : _express.Response,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], AuthController.prototype, "renderPasswordReset", null);
AuthController = _ts_decorate([
    (0, _common.Controller)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _usersservice.UsersService === "undefined" ? Object : _usersservice.UsersService,
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService,
        typeof _config.ConfigService === "undefined" ? Object : _config.ConfigService
    ])
], AuthController);
